/**
 * Scratch ripple effects rendered in a non-rotating overlay above the vinyl.
 * Receives effects array with screen-space percentage coordinates.
 */
import { motion, AnimatePresence } from "framer-motion";

export interface ScratchEffect {
  id: number;
  x: number;
  y: number;
}

interface ScratchEffectsProps {
  effects: ScratchEffect[];
}

const ScratchEffects = ({ effects }: ScratchEffectsProps) => {
  return (
    <>
      {/* Scratch effect ripples */}
      <AnimatePresence>
        {effects.map(effect => (
          <motion.div
            key={effect.id}
            className="absolute pointer-events-none"
            style={{
              left: `${effect.x}%`,
              top: `${effect.y}%`,
              transform: 'translate(-50%, -50%)',
            }}
            initial={{ opacity: 0.8, scale: 0 }}
            animate={{ opacity: 0, scale: 2.5 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <div className="w-16 h-16 rounded-full border-2 border-foreground/40" />
          </motion.div>
        ))}
      </AnimatePresence>

      {/* Scratch flash overlay */}
      <AnimatePresence>
        {effects.length > 0 && (
          <motion.div
            className="absolute inset-0 rounded-full pointer-events-none bg-foreground/10"
            initial={{ opacity: 1 }}
            animate={{ opacity: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default ScratchEffects;
